import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestTracking() {
  const catMap = Object.fromEntries(categories.map(c => [c.slug, c.name]));
  const latestArticles = [...articles].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  ).slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-1.5 h-5 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-400 font-label tracking-widest uppercase">
              REAL-TIME TRACKING
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            实时追踪
          </h2>
          <p className="text-sm text-foreground-500 mt-2">最新最热的网红塌房黑料，持续追踪报道</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.slug}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              imageUrl={article.imageUrl}
              category={article.category}
              categoryName={catMap[article.category] || article.category}
              publishedAt={article.publishedAt}
              views={article.views}
              comments={article.comments}
              isHot={article.isHot}
            />
          ))}
        </div>

        <div className="mt-10 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/30">
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-compass-3-fill text-primary-500 text-lg"></i>
            <h3 className="text-sm font-semibold text-foreground-700 font-label tracking-wide uppercase">
              探索吃瓜分类
            </h3>
          </div>
          <div className="flex flex-wrap gap-2 md:gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-200/50 hover:bg-primary-500/10 border border-background-200/30 hover:border-primary-500/30 text-sm text-foreground-600 hover:text-primary-400 transition-all duration-200 cursor-pointer"
              >
                <i className={`${cat.icon} text-sm`}></i>
                <span>{cat.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}